import { createSlice } from "@reduxjs/toolkit"

interface initialStateI {
    modalOpen: boolean;
}
const initialState: initialStateI = {
    modalOpen: true,
}
export const servicioEncuestaSatisfaccion = createSlice({
    name: 'servicioEncuestaSatisfaccion',
    initialState,
    reducers: {
        onModalOpen: (state, { payload }) => {
            state.modalOpen = payload;
        },
    },
});

export const { onModalOpen } = servicioEncuestaSatisfaccion.actions;